import React from "react";
import EditDonation from "../Donation/EditDonation";
import BackButton from "../../Components/BackButton";
import useTranslation from "../../utils/i18n/useTranslation";

const EditExpenses = () => {
  const { t } = useTranslation();
  return (
    <>
      <BackButton title={t("editExpenseTitle")} />
      <EditDonation collection={"expense"} />
    </>
  );
};

export default EditExpenses;
